import { combine, withCallbacks } from 'react-hooks-combine'
import { spec, validators } from 'utils/validation'
import { withFormModel } from 'shared/hooks'

import Step1FormComponent from './component'

const { string, any, custom } = validators

export default combine(
	withFormModel(
		{
			email: {
				alias: 'Email',
				spec: spec.flow(
					string.isString,
					string.isEmail,
					string.isNotEmpty,
					any.required
				),
			},

			nickName: {
				alias: 'Nickname',
				spec: spec.flow(
					string.isString,
					string.isNotEmpty,
					string.maxLength(12),
					string.minLength(1),
					any.required
				),
			},

			password: {
				alias: 'Password',
				spec: spec.flow(string.isString, string.isNotEmpty, any.required),
			},

			confirmation: {
				alias: 'Password Confirmation',
				spec: spec.flow(
					string.isString,
					custom.matchProp('password'),
					string.isNotEmpty,
					any.required
				),
			},
			firstName: {
				alias: 'First Name',
				spec: spec.flow(
					string.isString,
					string.isNotEmpty,
					any.required
				),
			},
			lastName: {
				alias: 'Last Name',
				spec: spec.flow(
					string.isString,
					string.isNotEmpty,
					any.required
				),
			},
		},
		{ id: 'step1-form' }
	),

	withCallbacks(
		{
			onSubmitForm: {
				deps: ['onSubmit'],
				func:
					(_state, { onSubmit }) =>
						(entity) => {
							// For step 1, we need the basic signup fields including confirmation
							const step1Data = {
								nickName: entity.nickName,
								email: entity.email,
								password: entity.password,
								confirmation: entity.confirmation,
								firstName: entity.firstName,
								lastName: entity.lastName,
							}

							return onSubmit(step1Data)
						},
			},
		},
		[]
	)
)(Step1FormComponent) 